const switchStepPOSList = ['cars-subscription', 'realestate-subscription', 'marketplace-subscription', 'jobs-subscription', 'services-subscription', 'autoparts-subscription', 'trucks-subscription', 'motorcycles-subscription', 'boats-subscription'];

export const getBaseName = pointOfSale => pointOfSale.replace(/\-b$/, ''); //eslint-disable-line
export const isSwitchStepPOS = pointOfSale => switchStepPOSList.includes(pointOfSale);
